import type { Maybe } from '@amazon/vinyl-util'
import type { ImageModel } from '@/components/ImageView'

export interface DetailPagePreSeed {
    /**
     * When transitioning from an item renderer, use its img source as the placeholder for the main image.
     * This allows for clean page transitions and a low-rez placeholder image.
     */
    readonly mainImage?: Maybe<ImageModel>
}

let pagePreSeed: DetailPagePreSeed | null = null

/**
 * Gets the detail page pre-seed then clears it.
 */
export function getDetailPagePreSeed(): DetailPagePreSeed | null {
    const seed = pagePreSeed
    pagePreSeed = null
    return seed
}

export function setDetailPagePreSeed(value: DetailPagePreSeed | null): void {
    pagePreSeed = value
}
